import { render, staticRenderFns } from "./ServiceCategories.vue?vue&type=template&id=31b83d7d&scoped=true&"
import script from "./ServiceCategories.vue?vue&type=script&lang=js&"
export * from "./ServiceCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b83d7d",
  null
  
)

export default component.exports